import { render, staticRenderFns } from "./ConsumptionReasonTable.vue?vue&type=template&id=08f3fccc&"
import script from "./ConsumptionReasonTable.vue?vue&type=script&lang=ts&"
export * from "./ConsumptionReasonTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports